import { jsx as _jsx } from "react/jsx-runtime";
import { Table } from "antd/es";
import Modal from "antd/es/modal/Modal";
const CertComments = ({ open, onClose, lstCmts, }) => {
    const columns = [
        {
            title: 'Provided By',
            dataIndex: 'strCommentByName',
            key: '1',
        },
        {
            title: 'Date/Time',
            dataIndex: 'dtCommentDate',
            key: '2'
        },
        {
            title: 'Message',
            dataIndex: 'strCommentDesc',
            key: '3'
        }
    ];
    return (_jsx(Modal, { title: 'View Comment History', width: 1000, open: open, onCancel: onClose, footer: null, children: _jsx(Table, { columns: columns, dataSource: lstCmts.map((item, index) => (Object.assign(Object.assign({}, item), { key: index }))) }) }));
};
export default CertComments;
